import Vue from 'vue'
import VueRouter from 'vue-router'
import major from '../views/major'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "index",
    component: major
  },
  {
    path: "/workbench",
    name: "工作台",
    component: () =>
      import(/* webpackChunkName: "Workbench" */ "../views/workbench/index")
  },
  {
    path: "/chat",
    name: "Chat",
    component: () =>
      import(/* webpackChunkName: "SYService" */ "../views/liveChat.vue")
  },
  {
    path: "/englishhome",
    name: "EnglishHome",
    component: () =>
      import(/* webpackChunkName: "SYService" */ "../views/englishhome/index.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 每次路由跳转时将滚动位置设置到顶部
    return { x: 0, y: 0 };
  }
});

export default router
